module.exports = __webpack_public_path__ + "static/media/Chawmein _ Arroz Frito.ec76ec9c.svg";